import * as React from 'react';
import { connect } from 'react-redux';
import ModernDatepicker from 'react-modern-datepicker';
import { setTime, setTimeShow, setDate,  checkDateTime, getDateString, submitWarrantyClaim, submitVapClaim } from '../../../../actions/claimSubmitActions';
import TimeKeeper from 'react-timekeeper';
import { DASHBOARD } from '../../../../routes/routes';
import { navigateTo } from '../../../../actions/navigationActions';
import '../../FNOL.css'
import { CLAIM_TYPE_WARRANTY } from '../../../../constants/constants';

class WarrantyClaimDetails extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            nextDisabled: true,
            Step1Submitted: false,
            hasDate: this.props.claimSubmit.incidentDate !== "",
            hasTime: this.props.claimSubmit.incidentTime !== "",
            hasTimeChanged: (this.props.claimSubmit.incidentTime != "") ? true : false,
            hasFutureDate: false,
            hasFutureTime: false,
            startDate: this.props.claimSubmit.incidentDate,
            Step1Disabled: false,
            time24: "12:00",
            time12: "12:00 pm",
            maxDate: new Date(),
            mouseOut: false,
            isClosed: false,
        };
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        this.handleIndidentDateClicked = this.handleIndidentDateClicked.bind(this);
        this.setTime = this.setTime.bind(this);
        this.handleStep1Submit = this.handleStep1Submit.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.checkTimeToggle = this.checkTimeToggle.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.setMouseOut = this.setMouseOut.bind(this);
        this.setMouseIn = this.setMouseIn.bind(this);
        this.listenAwayClick = this.listenAwayClick.bind(this);
        this.validateTime = this.validateTime.bind(this);
    }

    async setMouseOut() {
        await this.setState({ mouseOut: true });
        this.listenAwayClick();
    }

    async setMouseIn() {
        await this.setState({ mouseOut: false });
        this.listenAwayClick();
    }

    async handleClickAway() {
        if (!this.state.isClosed) {
            document.body.removeEventListener("click", this.handleClickAway);
        }
        if (this.state.hasTime) {
            this.setTime(this.state.time12, this.state.time24);
        }
        else {
            this.props.dispatchAction(setTimeShow());
        }
    }

    handleTimeChange(f12: any, f24: any) {
        this.setState({ hasTime: true, time12: f12, time24: f24 });
        this.props.dispatchAction(setTime(f12, f24));
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    async handleStepBack() {
        this.props.dispatchAction(navigateTo(DASHBOARD))
    }

    handleChangeDateValue(date) {
        this.setState({
            startDate: date
        });
        this.props.dispatchAction(setDate(date));
        this.setState({ hasDate: true });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchAction(setTimeShow());
        }
    }

    listenAwayClick() {
        if (this.state.mouseOut && !this.state.isClosed) {
            document.body.addEventListener("click", this.handleClickAway);
        }
        else {
            document.body.removeEventListener("click", this.handleClickAway);
        }
    }

    async validateTime(): Promise<any> {
        var dateString = getDateString(this.state.startDate, this.props.claimSubmit.time);
        var validation = await this.props.dispatchAction(checkDateTime(dateString));
        if (validation) {
            this.setState({
                hasFutureTime: validation.isFutureTime,
                hasFutureDate: validation.isFutureDate
            });
        }
        return validation;
    }

    async checkStep1Answers() {
        this.setState({ Step1Submitted: true })
        let dateValidation = await this.validateTime();

        if (dateValidation && (this.state.hasDate && !dateValidation.isFutureDate) && (this.state.hasTimeChanged && !dateValidation.isFutureTime)) {
            this.setState({ Step1Disabled: false })
        }
        else {
            this.setState({ Step1Disabled: true })
        }
    }

    async handleStep1Submit() {
        this.setState({ Step1Submitted: true })
        let dateValidation = await this.validateTime();

        if (dateValidation && (this.state.hasDate && !dateValidation.isFutureDate) && (this.state.hasTimeChanged && !dateValidation.isFutureTime)) {
            if (this.props.claimSubmit.claimType === CLAIM_TYPE_WARRANTY) {
                await this.props.dispatchAction(submitWarrantyClaim());
            }
            else {
                await this.props.dispatchAction(submitVapClaim());
            }
        } else {
            this.setState({ Step1Disabled: true })
        }
    }

    async handleIndidentDateClicked() {
        this.setState({
            isClosed: false,
        })
        document.body.addEventListener("click", this.handleClickAway);
    }

    checkTimeToggle() {
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchAction(setTimeShow());
        }
    }

    async setTime(f12: any, f24: any) {
        document.body.removeEventListener("click", this.handleClickAway);

        this.setState(prevState => {
            return {
                ...prevState,
                time12: f12, time24: f24,
                mouseOut: false,
                isClosed: true,
                hasTime: false, hasTimeChanged: true,
                hasFutureTime: false, hasFutureDate: false
            }
        }, (async () => {
            await this.props.dispatchAction(setTime(f12, f24))
            await this.props.dispatchAction(setTimeShow());
            if (this.state.Step1Submitted) {
                this.checkStep1Answers();
            }
        }).bind(this));
    }

    public render() {
        return (
            <div className="content-box-padding-20px-bottom-40px dropdown-extend">
                <div className="nopa ssp-header-fnol-claim-info">
                    <div className="row mb-10px ml-10px">
                        <div className="fnol-step-header-icon-area">
                            <img src='/my-policy/Images/Claims/Numbers/1-red.png' alt="Step 1" title="Step 1" />
                        </div>
                        <div className="col fnol-step-header-title-area">
                            <h3>Claim details</h3>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-form-section-holder">
                        <hr className="hr-minus21px" />
                        <p className="fnol-form-intro-p">
                            Before we can look into your claim,&nbsp;
                            <br className="mobile-br" />
                            we need a few details
                        </p>
                        <div className="ssp-form">
                            <div className="col-12 nopa ssp-form">
                                <div className={'form-group position-relative ' + ((this.state.Step1Submitted && !this.state.hasDate) || this.state.hasFutureDate ? 'has-error' : '')} onClick={this.checkTimeToggle}>
                                    <label className={'form-label ssp-calendar-label' + (this.state.startDate !== "" ? "" : " no-opacity")}>Incident date</label>
                                    <ModernDatepicker
                                        date={this.state.startDate}
                                        format={'DD-MM-YYYY'}
                                        showBorder
                                        onChange={(date) => this.handleChangeDateValue(date)}
                                        placeholder="Select incident date"
                                        maxDate={this.state.maxDate}
                                        id="FNOL-datepicker"
                                        className="ssp-calendar-input calendar-inline-icon"
                                    />
                                    {this.state.Step1Submitted && !this.state.hasDate &&
                                        <div className="form-inline-error">Date is required</div>
                                    }
                                    {this.state.Step1Submitted && this.state.hasFutureDate && this.state.hasDate &&
                                        <div className="form-inline-error">The date should not be in the future</div>
                                    }
                                </div>
                                {this.props.claimSubmit.timeDisplay &&
                                    <div className={'form-group position-relative ' + ((this.state.Step1Submitted && !this.state.hasTimeChanged) || this.state.hasFutureTime ? ' has-error' : '')} >
                                        {this.props.claimSubmit.timeDisplay &&
                                            <label className={'form-label' + (this.props.claimSubmit.timeDisplay ? "" : " no-opacity")}>Incident time</label>
                                        }
                                        <input type="button" className="form-control ssp-time-input text-left watch-inline-icon" value={this.props.claimSubmit.timeDisplay ? this.props.claimSubmit.timeDisplay : 'Select incident time'} disabled={this.props.isClosed} onClick={this.handleIndidentDateClicked} />
                                        <div className={this.props.claimSubmit.IsIncidentDateClicked ? 'visible w-100' : 'invisible'} onMouseLeave={this.setMouseOut} onMouseEnter={this.setMouseIn}>
                                            <TimeKeeper
                                                time={this.props.claimSubmit.timeDisplay}
                                                onChange={(newTime) => this.handleTimeChange(newTime.formatted12, newTime.formatted24)}
                                                doneButton={(newTime) => (
                                                    <div
                                                        className="btn btn-solid-red process"
                                                        onClick={() => this.setTime(newTime.formatted12, newTime.formatted24)}
                                                    >
                                                        Close
                                                    </div>
                                                )}
                                                switchToMinuteOnHourSelect
                                                closeOnMinuteSelect
                                            />
                                        </div>
                                        {this.state.Step1Submitted && !this.state.hasTimeChanged &&
                                            <div className="form-inline-error">Time is required</div>
                                        }

                                        {this.state.Step1Submitted && this.state.hasFutureTime && this.state.hasTimeChanged &&
                                            <div className="form-inline-error">The time should not be in the future</div>
                                        }
                                    </div>
                                }
                            </div>

                            <div className="col-12 nopa fnol-where-it-happened-buttonholder">
                                <button className="btn btn-solid-red fnol-where-it-happened-button-next" id="btn-info-next" disabled={this.state.Step1Disabled} onClick={this.handleStep1Submit}>Submit</button>
                                <button className="btn btn-outline-red fnol-where-it-happened-button-back" id="btn-info-back" onClick={this.handleStepBack}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(WarrantyClaimDetails)